import { render, staticRenderFns } from "./TooltipedTextLineCount.vue?vue&type=template&id=55599cea"
import script from "./TooltipedTextLineCount.vue?vue&type=script&lang=js"
export * from "./TooltipedTextLineCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports